// _app.tsx blurs the active element on every #main-element scroll to close
// the browser's native autocomplete dropdown. Programmatic scrolls (e.g.
// scrollIntoView while navigating inputs by keyboard) trigger that same
// listener, stealing focus mid-scroll. Callers wrap those scrolls with
// withSuppressedScrollBlur so the listener skips the blur while they run.
//
// A fixed-duration suppression isn't reliable: a smooth scrollIntoView's
// animation length depends on the distance scrolled, so a timer shorter
// than the actual scroll expires before it settles, letting the final
// scroll event (right as it stops) blur the input. Instead, every
// #main-element scroll event while suppression is active re-arms a
// "quiet period" timeout — suppression only lifts once scroll events stop
// arriving for QUIET_PERIOD_MS, i.e. once the scroll has actually settled.
const QUIET_PERIOD_MS = 150;
// Safety net in case scroll events stop firing unexpectedly (e.g. the
// element never actually scrolls) so suppression can't get stuck forever.
const MAX_SUPPRESS_MS = 2000;

let suppressed = false;
let quietTimer: number | undefined;
let maxTimer: number | undefined;

function clear(): void {
  suppressed = false;
  window.clearTimeout(quietTimer);
  window.clearTimeout(maxTimer);
}

export function isScrollBlurSuppressed(): boolean {
  return suppressed;
}

export function notifyScrollBlurSuppressedScrollEvent(): void {
  if (!suppressed) return;

  window.clearTimeout(quietTimer);
  quietTimer = window.setTimeout(clear, QUIET_PERIOD_MS);
}

export function withSuppressedScrollBlur(): void {
  suppressed = true;

  window.clearTimeout(quietTimer);
  quietTimer = window.setTimeout(clear, QUIET_PERIOD_MS);

  window.clearTimeout(maxTimer);
  maxTimer = window.setTimeout(clear, MAX_SUPPRESS_MS);
}
